import src from "./logo-lg.svg"

const width = 333
const height = 134
export default { src, width, height }
